//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex';
import TextLink from 'components/blocks/TextLink.vue'

export default {
  props: ['data'],
  block: ['article'],
  components: {
    TextLink,
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
    article() {
      return require("@/pages/news/"+this.$route.query.article+"/article.json");
    },
    src() {
      return require("@/pages/news/"+this.$route.query.article+"/"+this.article.imgSrc);
    },
  },
}



// WEBPACK FOOTER //
// ./components/blocks/Article.vue